import { computed } from 'vue';

/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-05 11:32:30
 * @LastEditors: luckymiaow
 */
export default ({ slots }, exclude: string[] = []) => {
  const useExcludeSlots = computed(() => {
    let obj = {};
    for (let slot in slots) {
      if (!exclude.includes(slot)) obj[slot] = slots[slot];
    }
    return obj;
  });

  return { useExcludeSlots };
};
